import Loadable from 'react-loadable';
import Loader from '../spinner/Loader';

export default loader =>
  Loadable({
    loader: loader,
    loading: Loader,
  });
